// LuxuryPage.jsx
import React from "react";
// import "./LuxuryPage.css";
import "../App.css";
import { useEnquiryModal } from "./EnquiryModal";
import { ENQUIRY_CTA } from "../constants";

const LuxuryPage = () => {
  const { openModal } = useEnquiryModal();
  return (
    <div id="about" className="luxury-page">
      {/* ----------- Section 1: Luxury Launch ----------- */}
      <section className="luxury-section">
        <div className="luxury-image">
          <img
            src="../Assets/banner2.webp"
            alt="Luxury View"
          />
        </div>
        <div className="luxury-text">
          <h2 className="font-semibold">
            Emaar Beachfront Dubai
          </h2>
          <p>
            Emaar Beachfront offers an exclusive, private island lifestyle at Dubai Harbour, combining luxury living with direct access to pristine beaches and the Arabian Gulf. This gated, off-plan community by Emaar Properties is strategically located near Sheikh Zayed Road, ensuring easy connectivity to Dubai Marina, Palm Jumeirah, and the city’s top attractions. Emaar Beachfront Apartments residents enjoy world-class shopping, gourmet dining, prestigious yacht clubs, and vibrant entertainment just moments away. Wake to sea views, relax on white sand, and experience a refined coastal lifestyle where convenience, elegance, and breathtaking surroundings redefine premium living standards.
          </p>
          <button onClick={() => openModal(ENQUIRY_CTA.INTRO)} className="mt-4 font-semibold border-2 rounded-md border-[#997736] text-[#997736] hover:text-white px-6 py-2 hover:bg-[#997736] transition">DOWNLOAD BROCHURE</button>
        </div>
      </section>

      {/* ----------- Section 2: Amenities ----------- */}
      {/* <section className="amenities-section">
        <div className="carousel-half">
          <Swiper
            modules={[Navigation]}
            navigation
            spaceBetween={10}
            slidesPerView={1}
            className="swiper-amenities"
          >
            <SwiperSlide>
              <img
                src="../Assets/a1.jpg"
                alt="Amenities 1"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="../Assets/a2.jpg"
                alt="Amenities 2"
              />
            </SwiperSlide>
          </Swiper>
        </div>
        <div className="text-half">
          <h2>AMENITIES</h2>
          <p>
            Live the high life at Luxury Launch with exclusive amenities like an
            infinity pool, gym, yoga deck, landscaped gardens, and more – crafted
            to offer unmatched comfort, elegance, and everyday indulgence.
          </p>
          <button className="btn-download">DOWNLOAD AMENITIES</button>
        </div>
      </section> */}

      {/* ----------- Section 3: Gallery ----------- */}
      {/* <section className="gallery-section">
        <div className="text-half">
          <h2>GALLERY</h2>
          <p>
            Explore the gallery of Project to get a glimpse of its stunning
            architecture, luxurious interiors, premium amenities, and vibrant
            lifestyle – a visual preview of the life that awaits you.
          </p>
          <button className="btn-download">DOWNLOAD GALLERY</button>
        </div>
        <div className="carousel-half">
          <Swiper
            modules={[Navigation]}
            navigation
            spaceBetween={10}
            slidesPerView={1}
            className="swiper-gallery"
          >
            <SwiperSlide>
              <img
                src="../Assets/g1.jpg"
                alt="Gallery 1"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="../Assets/g2.jpg"
                alt="Gallery 2"
              />
            </SwiperSlide>
          </Swiper>
        </div>
      </section> */}
    </div>
  );
};

export default LuxuryPage;
